export default {
      id: "filter-usage",
      viewBox: "0 0 23 24",
      url: __webpack_public_path__ + "img/icons.ec9c9113.svg#filter",
      toString: function () {
        return this.url;
      }
    }